import {memo, useMemo, useState} from 'react';
import style from './style.module.scss';
import Link from 'components/Link';
import {Typography} from 'components/Typography';
import classNames from 'classnames';

type TTuplesLink = {
    href: string;
    title: string;
};

interface ITuplesLinksProps {
    linkList: TTuplesLink[];
    limit: number;
}

type TTriggerProps = {
    text: string;
    onClick: () => void;
};

const Trigger = ({text, onClick}: TTriggerProps) => (
    <div className={style.trigger} onClick={onClick}>
        <Typography variant={'h5-medium'}>{text}</Typography>
    </div>
);

const LinkItem = ({href, title}: TTuplesLink) => (
    <div className={style.item}>
        <Link href={href} isUnderlining={true} text={title} theme={'black'} variant={'h5-medium'} />
    </div>
);

const TuplesLinks = memo<ITuplesLinksProps>(function ({linkList, limit}) {
    const [isVisible, setIsVisible] = useState<boolean>(false);

    const {firstPart, lastPart} = useMemo(() => {
        return {
            firstPart: linkList.slice(0, limit),
            lastPart: linkList.slice(limit),
        };
    }, [linkList, limit]);

    return (
        <div>
            {firstPart.map(({title, href}, index) => (
                <LinkItem href={href} key={index} title={title} />
            ))}
            {!isVisible && <Trigger onClick={() => setIsVisible(true)} text={'еще'} />}

            <div
                className={classNames(style.moreContent, {
                    [style.visible]: isVisible,
                })}
            >
                {lastPart.map(({title, href}, index) => (
                    <LinkItem href={href} key={index} title={title} />
                ))}
                <Trigger onClick={() => setIsVisible(false)} text={'свернуть'} />
            </div>
        </div>
    );
});

export default TuplesLinks;
